/* HARDLINE · interações do tema (sem dependências) */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const HL = window.HL || {};
  const money = (cents) => {
    const v = (cents / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  };
  HL.money = money;

  /* ---------- Toast ---------- */
  let toastTimer;
  HL.toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '<i></i><span></span>'; t.querySelector('span').textContent = msg;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-visible'), 3200);
  };

  /* ---------- Drawers ---------- */
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    const f = d.querySelector('button, a, input'); f && setTimeout(() => f.focus(), 50);
  };
  const closeDrawer = (d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  HL.openDrawer = openDrawer;
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.openDrawer); return; }
    const c = e.target.closest('[data-close-drawer]');
    if (c) { closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- Header: esconde ao rolar para baixo ---------- */
  const header = $('.site-header');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 300 && y > last + 6 && !$('.mega:hover')) header.classList.add('is-hidden');
      else if (y < last - 6 || y < 300) header.classList.remove('is-hidden');
      last = y;
    }, { passive: true });
  }

  /* ---------- Busca com sugestões ---------- */
  const sToggle = $('[data-search-toggle]'), sBar = $('.search-bar');
  if (sToggle && sBar) {
    sToggle.addEventListener('click', () => { sBar.classList.toggle('is-open'); if (sBar.classList.contains('is-open')) $('input', sBar).focus(); });
    const input = $('input[name="q"]', sBar), out = $('.predictive', sBar); let tm;
    input && input.addEventListener('input', () => {
      clearTimeout(tm); const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      tm = setTimeout(async () => {
        try {
          const r = await fetch(`${HL.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const j = await r.json(); const ps = (j.resources && j.resources.results.products) || [];
          out.innerHTML = ps.map(p => `<a href="${p.url}"><img src="${p.image || ''}" alt="" loading="lazy"><span>${p.title}<br><small>${p.vendor || ''}</small></span><b>${money(Math.round(parseFloat(p.price) * 100))}</b></a>`).join('') ||
            `<p style="color:var(--hl-muted)">Nada encontrado para “${q.replace(/</g, '')}”.</p>`;
        } catch (err) { out.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Carrinho (AJAX + drawer) ---------- */
  const Cart = {
    async refresh(open) {
      try {
        const r = await fetch(`${HL.routes.root}?sections=cart-drawer`);
        const j = await r.json();
        const html = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        const fresh = html.querySelector('#CartDrawer .drawer__panel'), cur = $('#CartDrawer .drawer__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        const cnt = html.querySelector('[data-cart-count-src]');
        $$('[data-cart-count]').forEach(el => { el.textContent = cnt ? cnt.dataset.cartCountSrc : ''; el.dataset.count = cnt ? cnt.dataset.cartCountSrc : 0; });
        if (open) openDrawer('CartDrawer');
      } catch (e) { if (open) window.location.href = HL.routes.cart; }
    },
    async add(form, btn) {
      btn && btn.classList.add('is-loading');
      try {
        const r = await fetch(`${HL.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const j = await r.json();
        if (j.status) { HL.toast(j.description || 'Não foi possível adicionar.'); return; }
        if (HL.cartType === 'page') { window.location.href = HL.routes.cart; return; }
        await Cart.refresh(true);
      } catch (e) { form.submit(); }
      finally { btn && btn.classList.remove('is-loading'); }
    },
    async change(line, quantity) {
      const r = await fetch(`${HL.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!r.ok) { const j = await r.json(); HL.toast(j.description || 'Quantidade indisponível.'); }
      await Cart.refresh(false);
    }
  };
  HL.Cart = Cart;
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-ajax-cart]');
    if (!f) return; e.preventDefault(); Cart.add(f, f.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (b) { e.preventDefault(); Cart.change(+b.dataset.line, +b.dataset.lineQty); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('input[data-line-input]');
    if (i) Cart.change(+i.dataset.lineInput, Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach((hero) => {
    const slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero);
    if (slides.length < 2) return;
    const speed = (+hero.dataset.speed || 6) * 1000; hero.style.setProperty('--hero-speed', speed / 1000 + 's');
    let i = 0, timer;
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) { dots[i].classList.remove('is-active'); void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
      clearTimeout(timer); if (hero.dataset.autoplay === 'true') timer = setTimeout(() => go(i + 1), speed);
    };
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    $('[data-hero-prev]', hero) && $('[data-hero-prev]', hero).addEventListener('click', () => go(i - 1));
    $('[data-hero-next]', hero) && $('[data-hero-next]', hero).addEventListener('click', () => go(i + 1));
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    go(0);
  });

  /* ---------- Sliders horizontais ---------- */
  const initSlider = (s) => {
    const track = $('.slider__track', s); if (!track || track.dataset.ready) return; track.dataset.ready = 1;
    const prev = $('[data-slide-prev]', s.closest('[data-slider-root]') || s), next = $('[data-slide-next]', s.closest('[data-slider-root]') || s);
    const bar = $('.slider__bar i', s.closest('[data-slider-root]') || s);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev && (prev.disabled = track.scrollLeft < 4); next && (next.disabled = track.scrollLeft > max - 4);
      if (bar) { const w = Math.max(12, track.clientWidth / track.scrollWidth * 100); bar.style.width = w + '%'; bar.style.left = (max > 0 ? track.scrollLeft / max * (100 - w) : 0) + '%'; }
    };
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : 300; };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  };
  $$('.slider').forEach(s => { if (!s.closest('[hidden]')) initSlider(s); });

  /* ---------- Abas ---------- */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach(x => { x.setAttribute('aria-selected', 'false'); x.tabIndex = -1; const p = document.getElementById(x.getAttribute('aria-controls')); p && (p.hidden = true); });
      t.setAttribute('aria-selected', 'true'); t.tabIndex = 0;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = false; panel.classList.remove('is-entering'); void panel.offsetWidth; panel.classList.add('is-entering');
        // controles do slider passam a mirar o painel ativo
        const s = $('.slider', panel); if (s) { root.dataset.active = panel.id; initSlider(s); bindCtrl(root, s); }
      }
    }));
    tabs.forEach((t, n) => t.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { const k = (n + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tabs[k].focus(); tabs[k].click(); }
    }));
    const first = $('.tab-panel:not([hidden]) .slider', root); first && bindCtrl(root, first);
  });
  function bindCtrl(root, slider) {
    const track = $('.slider__track', slider), prev = $('[data-tab-prev]', root), next = $('[data-tab-next]', root), bar = $('[data-tab-bar] i', root);
    if (!track) return;
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev && (prev.disabled = track.scrollLeft < 4); next && (next.disabled = track.scrollLeft > max - 4);
      if (bar) { const w = Math.max(12, track.clientWidth / track.scrollWidth * 100); bar.style.width = w + '%'; bar.style.left = (max > 0 ? track.scrollLeft / max * (100 - w) : 0) + '%'; }
    };
    if (prev) prev.onclick = () => track.scrollBy({ left: -step(), behavior: 'smooth' });
    if (next) next.onclick = () => track.scrollBy({ left: step(), behavior: 'smooth' });
    track.onscroll = update; update();
  }

  /* ---------- Revelar ao rolar + contadores ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => {
    ents.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in'); io.unobserve(en.target);
      $$('[data-count-to]', en.target).forEach(countUp);
      if (en.target.matches('[data-count-to]')) countUp(en.target);
    });
  }, { threshold: .14, rootMargin: '0px 0px -40px 0px' }) : null;
  $$('[data-count-to]').forEach(el => { if (io) el.textContent = '0'; });
  $$('[data-reveal],[data-reveal-stagger],[data-count-to]').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  function countUp(el) {
    if (el.dataset.done) return; el.dataset.done = 1;
    const to = parseFloat(el.dataset.countTo) || 0, dur = 1400, t0 = performance.now();
    const tick = (t) => { const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e).toLocaleString('pt-BR'); if (p < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  }

  /* ---------- Página de produto ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('script[data-product-json]', root); if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('form[data-product-form]', root), idInput = form && $('input[name="id"]', form);
    const inst = +root.dataset.instCount || 6, pix = +root.dataset.pixPct || 0;

    const selected = () => $$('fieldset.opt', root).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (opts) => product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    const markAvailability = (opts) => {
      $$('fieldset.opt', root).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = opts.slice(); test[idx] = inp.value;
          const v = findVariant(test);
          const lbl = inp.nextElementSibling; lbl && lbl.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    const render = (v) => {
      const opts = selected(); markAvailability(opts);
      $$('[data-selected-value]', root).forEach((el, i) => el.textContent = opts[i] || '');
      const btns = $$('[data-atc]'), skuEl = $$('[data-sku]', root.ownerDocument);
      if (!v) { btns.forEach(b => { b.disabled = true; b.querySelector('span').textContent = 'Indisponível'; }); return; }
      idInput && (idInput.value = v.id);
      skuEl.forEach(el => el.textContent = v.sku || '-');
      $$('[data-price]').forEach(el => el.textContent = money(v.price));
      $$('[data-compare]').forEach(el => { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
      $$('[data-off]').forEach(el => { const off = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0; el.hidden = !off; el.textContent = `-${off}%`; });
      $$('[data-inst]').forEach(el => el.innerHTML = `ou <b>${inst}x de ${money(Math.floor(v.price / inst))}</b> sem juros no cartão`);
      $$('[data-pix]').forEach(el => { el.hidden = !pix; el.textContent = `${money(Math.round(v.price * (1 - pix / 100)))} no Pix (${pix}% off)`; });
      const stock = $('[data-stock]', root);
      if (stock) {
        const q = v.inventory_quantity, managed = v.inventory_management === 'shopify';
        stock.classList.remove('is-low', 'is-out');
        if (!v.available) { stock.classList.add('is-out'); stock.querySelector('span').textContent = 'Esgotado nesta opção - fale com a gente para encomendar'; }
        else if (managed && q > 0 && q <= 3) { stock.classList.add('is-low'); stock.querySelector('span').textContent = `Últimas ${q} unidades`; }
        else stock.querySelector('span').textContent = 'Em estoque - pronta entrega';
      }
      btns.forEach(b => { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? (b.dataset.label || 'Adicionar ao carrinho') : 'Esgotado'; });
      if (v.featured_media) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, root);
        slide && goSlide(+slide.dataset.index);
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      $$('[data-wa-product]').forEach(a => { const base = a.dataset.waBase; a.href = base + encodeURIComponent(`${a.dataset.waText} ${product.title}${v.title !== 'Default Title' ? ' (' + v.title + ')' : ''} - SKU ${v.sku || ''}`); });
    };
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset.opt')) render(findVariant(selected())); });

    // galeria
    const track = $('.gallery__track', root), thumbs = $$('.gallery__thumb', root), counter = $('.gallery__counter', root);
    const slides = track ? $$('.gallery__slide', track) : [];
    function goSlide(n) { if (!track || !slides[n]) return; track.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' }); }
    thumbs.forEach((t, n) => t.addEventListener('click', () => goSlide(n)));
    track && track.addEventListener('scroll', () => {
      const n = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === n));
      counter && (counter.textContent = `${n + 1} / ${slides.length}`);
    }, { passive: true });
    slides.forEach(s => {
      s.addEventListener('click', () => s.classList.toggle('is-zoom'));
      s.addEventListener('mousemove', (e) => { if (!s.classList.contains('is-zoom')) return; const r = s.getBoundingClientRect(); const img = s.querySelector('img'); img.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`; });
      s.addEventListener('mouseleave', () => s.classList.remove('is-zoom'));
    });

    // quantidade
    $$('[data-qty-step]', root).forEach(b => b.addEventListener('click', () => { const i = $('input[name="quantity"]', root); i.value = Math.max(1, (+i.value || 1) + (+b.dataset.qtyStep)); }));

    // barra fixa de compra
    const sticky = $('.sticky-atc'), mainBtn = form && $('[data-atc]', form);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); document.body.classList.toggle('has-sticky-atc', show);
      }).observe(mainBtn);
      const sb = $('[data-sticky-atc]', sticky); sb && sb.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
    const initial = product.variants.find(v => v.id === +(idInput && idInput.value)) || product.variants[0];
    render(initial);
  });

  /* ---------- Coleção: filtros enviam sozinhos ---------- */
  $$('form[data-filter-form]').forEach((f) => {
    let tm;
    f.addEventListener('change', (e) => { if (e.target.matches('input[type="number"]')) return; f.requestSubmit ? f.requestSubmit() : f.submit(); });
    f.addEventListener('input', (e) => { if (!e.target.matches('input[type="number"]')) return; clearTimeout(tm); tm = setTimeout(() => f.requestSubmit ? f.requestSubmit() : f.submit(), 900); });
    f.addEventListener('submit', () => { $$('input[type="number"]', f).forEach(i => { if (!i.value) i.disabled = true; }); });
  });
  $$('select[data-sort]').forEach(s => s.addEventListener('change', () => {
    const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString();
  }));
  $$('[data-filters-toggle]').forEach(b => b.addEventListener('click', () => { const p = document.getElementById('Filters'); p && p.classList.toggle('is-open'); }));

  /* ---------- Formulário de serviço -> WhatsApp ---------- */
  $$('[data-wa-form]').forEach((btn) => btn.addEventListener('click', () => {
    const f = btn.closest('form'), get = (n) => { const el = f.querySelector(`[name="contact[${n}]"]`); return el ? el.value.trim() : ''; };
    const lines = ['Olá, Hardline! Quero agendar um serviço na oficina.',
      get('Nome') && `Nome: ${get('Nome')}`, get('Serviço') && `Serviço: ${get('Serviço')}`,
      get('Bike') && `Bike: ${get('Bike')}`, get('Data preferida') && `Data preferida: ${get('Data preferida')}`,
      get('body') && `Detalhes: ${get('body')}`].filter(Boolean).join('\n');
    window.open(`https://wa.me/${HL.whatsapp}?text=${encodeURIComponent(lines)}`, '_blank', 'noopener');
  }));
  // pré-seleciona serviço vindo de um card (?servico=)
  const pre = new URLSearchParams(location.search).get('servico');
  if (pre) { const sel = $('select[name="contact[Serviço]"]'); if (sel) { [...sel.options].forEach(o => { if (o.value === pre) sel.value = pre; }); } }
  $$('[data-pick-service]').forEach(a => a.addEventListener('click', (e) => {
    const sel = $('select[name="contact[Serviço]"]'); if (!sel) return;
    e.preventDefault(); sel.value = a.dataset.pickService; sel.closest('form').scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => sel.focus(), 600);
  }));

  window.HL = HL;
})();
